import { joinDateAndTime } from "helpers";

import { CreateCouponBody } from "../apis";
import { CouponType } from "../constants";
import { CouponFormValues } from "../coupons.types";

export const convertCouponFormValuesToCreateRequestBody = (
  formValues: CouponFormValues,
  type: CouponType
): CreateCouponBody => {
  const from =
    formValues.fromDate && formValues.fromTime
      ? joinDateAndTime(formValues.fromDate, formValues.fromTime)
      : undefined;
  const to =
    formValues.toDate && formValues.toTime && !formValues.isUnlimited
      ? joinDateAndTime(formValues.toDate, formValues.toTime)
      : undefined;

  const metadata: Record<string, unknown> = {};

  if (type === CouponType.InfluencerCoupon) {
    if (formValues.influencerIdWhoGivenInfluencerCoupon) {
      metadata.influencerIdWhoGivenInfluencerCoupon =
        formValues.influencerIdWhoGivenInfluencerCoupon;
    }

    // Always sent, never inferred: a permanent code created as a campaign code
    // discounts orders and links nobody, so the influencer silently stops
    // earning after the first order.
    metadata.isPermanentInfluencerCode = Boolean(
      formValues.isPermanentInfluencerCode
    );
  }

  return {
    code: formValues.code,
    type,
    usageScope: formValues.usageScope,
    discountPercentage:
      formValues.discountType === "percentage"
        ? Number(formValues.discountPercentage)
        : 0,
    discountAmount:
      formValues.discountType === "amount"
        ? Number(formValues.discountAmount)
        : 0,
    from,
    to,
    requirements: {
      numberOfSharedProducts:
        Number(formValues.numberOfSharedProducts) || undefined,
      quantityResold: Number(formValues.quantityResold) || undefined,
      amountResold: Number(formValues.amountResold) || undefined,
      ordersResold: Number(formValues.ordersResold) || undefined,
      cartAmount: Number(formValues.cartAmount) || undefined
    },
    metadata
  };
};
